import "./style.css";
import React from "react";

import Container from "components/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Logo({ image, text, faIcon }) {
	return (
		<Container containerClass="logo-container">
			<Container containerClass="portrait-container">
				<img
					alt="portrait-photo"
					src={image}
					className="portrait-image"
					title=""
				></img>
				<img
					alt="upscaled-image"
					src={image}
					className="upscaled-image"
				/>
			</Container>

			<p className="logo-text">
				{text}
			</p>
			{faIcon ? <FontAwesomeIcon icon={faIcon} /> : null}
		</Container>
	);
}
